import { render, staticRenderFns } from "./footerbar.vue?vue&type=template&id=70eff253&scoped=true"
import script from "./footerbar.vue?vue&type=script&lang=js"
export * from "./footerbar.vue?vue&type=script&lang=js"
import style0 from "./footerbar.vue?vue&type=style&index=0&id=70eff253&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eff253",
  null
  
)

export default component.exports